<template>
  <div id="sale-order-list">
    <!-- user total card -->
    <v-row class="mb-5">
      <!--<v-col
        v-for="total in saleOrderTotalLocal"
        :key="total.total"
        cols="12"
        sm="6"
        md="3"
      >
        <v-card>
          <v-card-text class="d-flex align-center justify-space-between pa-4">
            <div>
              <h2 class="font-weight-semibold mb-1">
                {{ total.total }}
              </h2>
              <span>{{ total.title }}</span>
            </div>

            <v-avatar
              :color="resolveItemTotalIcon(total.title).color"
              :class="`v-avatar-light-bg ${resolveItemTotalIcon(total.title).color}--text`"
            >
              <v-icon
                size="25"
                :color="resolveItemTotalIcon(total.title).color"
                class="rounded-0"
              >
                {{ resolveItemTotalIcon(total.title).icon }}
              </v-icon>
            </v-avatar>
          </v-card-text>
        </v-card>
      </v-col> -->
    </v-row>

    <!-- list filters -->
    <v-card>
      <v-card-title>
        Search &amp; Filter
      </v-card-title>
      <v-row class="px-2 ma-0">
        <!-- role filter -->
        <!-- <v-col
          cols="12"
          sm="4"
        >
          <v-select
            v-model="roleFilter"
            placeholder="Select Role"
            :items="roleOptions"
            item-text="title"
            item-value="value"
            outlined
            clearable
            dense
            hide-details
          ></v-select>
        </v-col> -->

        <!-- plan filter -->
        <!-- <v-col
          cols="12"
          sm="4"
        >
          <v-select
            v-model="planFilter"
            placeholder="Select Plan"
            :items="planOptions"
            item-text="title"
            item-value="value"
            outlined
            dense
            clearable
            hide-details
          ></v-select>
        </v-col> -->

        <!-- status filter -->
        <!-- <v-col
          cols="12"
          sm="4"
        >
          <v-select
            v-model="statusFilter"
            placeholder="Select Status"
            :items="statusOptions"
            item-text="title"
            item-value="value"
            outlined
            dense
            clearable
            hide-details
          ></v-select>
        </v-col> -->
      </v-row>

      <!-- <v-divider class="mt-4"></v-divider> -->

      <!-- actions -->
      <!-- <v-card-text class="d-flex align-center flex-wrap pb-0">
        <v-row
          align="center"
          align-content="center"
          justify="space-between"
        >
          <v-col
            cols="12"
            md="8"
          >
            <table-search
              v-model="options.q"
              dense
              outlined
              hide-details
              full-width
            />
          </v-col>
        </v-row>
      </v-card-text> -->

      <!-- table -->
      <vuex-table
        :headers="tableColumns"
        :items="saleOrders"
        :options="options"
        :search.sync="search"
        :meta.sync="meta"
        :loading="loading"
        :footer-props="{
          'items-per-page-options': [5, 10, 25, 50, 100]
        }"
        @update:options="o => options = o"
      >
        <!-- number -->
        <template #[`item.number`]="{item}">
          <router-link
            :to="{ name : 'sale-order-view', params : { id : item.id } }"
            class="text--primary font-weight-semibold text-truncate cursor-pointer text-decoration-none"
          >
            {{ item.number }}
          </router-link>
        </template>

        <!-- customer -->
        <template #[`item.customerName`]="{item}">
          <router-link
            :to="{ name : 'customer-view', params : { id : item.customerId } }"
            class="text--primary font-weight-semibold text-truncate cursor-pointer text-decoration-none"
          >
            <div class="d-flex flex-column">
              <span class="d-block text--primary  font-weight-semibold text-truncate">{{ item.customerName }}</span>
              <span class="text-xs text--secondary font-weight-light">{{ item.email }}</span>
            </div>
          </router-link>
        </template>

        <!-- totalAmountIncludingTax with currencyCode -->
        <template #[`item.totalAmountIncludingTax`]="{item}">
          <span v-if="item.currencyCode">{{ `${item.currencyCode} ` }}</span>
          <span>{{ item.totalAmountIncludingTax }}</span>
        </template>

        <!-- parent name -->
        <template #[`item.status`]="{item}">
          <div class="d-flex">
            <v-chip
              small
              class="v-chip-light-bg secondary--text font-weight-semibold text-uppercase me-1"
            >
              {{ item.status }}
            </v-chip>
            <v-chip
              small
              :color="item.fullyShipped ? 'primary' : 'secondary'"
              class="v-chip-light-bg font-weight-semibold"
              :class="`${item.fullyShipped ? 'primary' : 'secondary'}--text`"
            >
              FULLY SHIPPED
            </v-chip>
          </div>
        </template>

        <!-- actions -->
        <template #[`item.actions`]="{item}">
          <v-tooltip bottom>
            <template #activator="{ on, attrs }">
              <v-btn
                icon
                small
                v-bind="attrs"
                :to="{ name: 'sale-order-view', params: { id: item.id } }"
                v-on="on"
              >
                <v-icon size="18">
                  {{ icons.mdiEyeOutline }}
                </v-icon>
              </v-btn>
            </template>
            <span>View Sale Order</span>
          </v-tooltip>
        </template>
      </vuex-table>
    </v-card>
  </div>
</template>

<script>
import { onMounted, onUnmounted } from '@vue/composition-api'
// eslint-disable-next-line object-curly-newline
import { mdiEyeOutline, mdiExportVariant } from '@mdi/js'
import useSaleOrderList from './useSaleOrderList'

export default {
  setup() {
    const {
      saleOrderListTable,
      tableColumns,
      roleFilter,
      planFilter,
      statusFilter,
      totalSaleOrderListTable,
      loading,
      saleOrderTotalLocal,

      resolveItemTotalIcon,

      saleOrders,
      meta,

      options,
      filters,
      search,

      resolveIcon,
      resolveColor,
      resolveColoredIcon,

      init,
      destroy,
    } = useSaleOrderList()

    onMounted(() => {
      init()
    })
    onUnmounted(() => {
      destroy()
    })

    const roleOptions = [
      { title: 'Admin', value: 'admin' },
      { title: 'User', value: 'user' },
    ]

    return {
      saleOrderListTable,
      tableColumns,
      roleFilter,
      planFilter,
      statusFilter,
      totalSaleOrderListTable,
      roleOptions,

      loading,
      saleOrderTotalLocal,

      resolveItemTotalIcon,

      saleOrders,
      meta,

      options,
      filters,
      search,

      icons: {
        mdiEyeOutline,
        mdiExportVariant,
      },

      resolveIcon,
      resolveColor,
      resolveColoredIcon,
    }
  },
}
</script>

<style lang="scss">
@import '@core/preset/preset/apps/user.scss';
</style>
